/* eslint-disable no-unused-vars */
export enum Permission{
    ADMIN = 'ROLE_ADMIN',
    USER = 'ROLE_USER',
}